module.exports = __webpack_public_path__ + "fonts/CircularStd-Medium.a453dcb0.ttf";